import React from 'react';
import { ApplicationsIcon, ArchiveIcon, CellTowerIcon, DatabaseIcon, PaneProps, ProjectsIcon, SendToGraphIcon } from 'evergreen-ui';
import { DATASOURCES, MESSAGES, PASSPORT, PROFILE, TELEGRAMS, TIMESERIES_DATA } from 'Features/routePaths';
import { LinkIconsWithTooltip, NavLinkButtons } from 'Shared/LinkButtons';
import { getStationPath } from './utils';

const iconControls = [
  {
    to: PASSPORT,
    name: 'Паспорт',
    icon: ProjectsIcon,
  },
  {
    to: TELEGRAMS,
    name: 'Телеграммы',
    icon: CellTowerIcon,
  },
  {
    to: DATASOURCES,
    name: 'Источники данных',
    icon: SendToGraphIcon,
  },
  {
    to: PROFILE,
    name: 'Профиль',
    icon: ApplicationsIcon,
  },
  {
    to: MESSAGES,
    name: 'Сообщения',
    icon: ArchiveIcon,
  },
  {
    to: TIMESERIES_DATA,
    name: 'Данные',
    icon: DatabaseIcon,
  },
];

// note: наследуем от PaneProps, так как обе обертки для кнопок наследуют от них
export type IconControlsProps = PaneProps & {
  stationId: number,
  /**
   * `true` - кнопки с названиями справа от иконки,
   * `false` - кнопки-иконки с подсказками
   * @default false
  */
  isExpanded?: boolean,
}

/** Элементы навигации для станции */
export function StationIconControls({ stationId, isExpanded = false, ...paneProps }: IconControlsProps) {
  const toStationPath = stationId ? `${getStationPath(stationId)}/` : undefined;
  if (isExpanded) {
    return (
      <NavLinkButtons
        buttons={iconControls}
        pathPrefix={toStationPath}
        {...paneProps}
      />
    );
  }
  return (
    <LinkIconsWithTooltip
      buttons={iconControls}
      pathPrefix={toStationPath}
      {...paneProps}
    />
  );
}
export const MemoStationIconControls = React.memo(StationIconControls);
MemoStationIconControls.displayName = 'MemoStationIconControls';
export default StationIconControls;
